(function(jQuery, Drupal, focusTrap) {
  'use strict';

  Drupal.behaviors.globalHeader = {
    attach: function(context, settings) {
      const mobileMenuBreakpoint = 1200;
      const $globalHeader = jQuery('.global-navbar');
      let winResizeBounce;

      const $headerRegion = $globalHeader.find('.region-header');
      const $regionHeaderNavigation = $globalHeader.find('.region-header-navigation');
      const $regionHeaderUtility = $globalHeader.find('.region-header-utility');
      const $toggleBtn = $globalHeader.find('.navbar-toggler');

      const focusTrapsOptions = {
        escapeDeactivates: false,
        clickOutsideDeactivates: true
      };

      const focusTraps = {}; // collection of focus traps
      if (window.innerWidth < mobileMenuBreakpoint) {
        focusTraps.header = focusTrap.createFocusTrap($globalHeader[0], focusTrapsOptions);
      }

      /**
       * Re-order header blocks when they change visual order
       *
       * Sort to original DOM order (data-order)
       * Then sort based on css flex order.
       */
      function headerTabIndexFix() {
        const $headerBlocks = $globalHeader.children();
        // Track the blocks' original order
        if (!$headerBlocks.first().attr('data-order')) {
          $headerBlocks.each(function(i) {
            const $block = jQuery(this);
            $block.attr('data-order', i);
          });
        }
        // sort by DOM order
        $headerBlocks
          .sort(function(a, b) {
            const $a = jQuery(a);
            const $b = jQuery(b);
            let orderA = parseInt($a.attr('data-order'));
            let orderB = parseInt($b.attr('data-order'));
            return (orderA < orderB) ? -1 : (orderA > orderB) ? 1 : 0;
          })
          // Sort by flex order
          .sort(function(a, b) {
            const $a = jQuery(a);
            const $b = jQuery(b);
            let orderA = parseInt($a.css('order'));
            let orderB = parseInt($b.css('order'));
            return (orderA < orderB) ? -1 : (orderA > orderB) ? 1 : 0;
          })
          // Re-order within the DOM to match visual order
          .appendTo($globalHeader);
      }

      /**
       * Position header collapse relative to the top so they can be absolute
       */
      function headerCollapsePinTop() {
        $regionHeaderNavigation.removeAttr('style');
        $regionHeaderUtility.removeAttr('style');

        if (window.innerWidth < mobileMenuBreakpoint) {
          var hH = $globalHeader.outerHeight(true);
          $regionHeaderNavigation.css({'top': hH + 'px'});
          var nH = $regionHeaderNavigation.outerHeight(true);
          $regionHeaderUtility.css({'top': (hH + nH) + 'px'});
        }
      }

      /**
       * Position the mega menu to the left edge of the window
       * break it out of its parent
       */
      function alignMegaMenuLeft($menu) {
        if (window.innerWidth > mobileMenuBreakpoint) {
          $menu.css({'left': '', 'right': ''});
          let l = $menu.parent().offset().left;
          l = 0 - l;
          $menu.css({'left': l, 'right': 'unset'});
        }
      }

      /**
       * Set single column dropdowns to not exceeed the available space in the content container.
       * Or to hang from the right if extra space is needed.
       */
      const setDropdownWidth = function($dropdown) {
        if (window.innerWidth > mobileMenuBreakpoint &&
          !$dropdown.hasClass('dropdown-style-mega-menu') &&
          $dropdown.attr('data-width-set') !== window.innerWidth.toString()) {

          $dropdown.css({'width': ''});
          let w = 0;
          let min = 400;
          const oL = $dropdown.parent().offset().left;
          let max = window.innerWidth - oL - 50;

          // find max-width in terms of screen size
          $dropdown.find('.nav-item').css({'white-space': 'nowrap', 'display': 'block'});
          w = $dropdown.width();
          $dropdown.find('.nav-item').css({'white-space': '', 'display': ''});

          if (max < min) {
            max = min;
            $dropdown.addClass('hang-right'); // attach to the right, rather than the left
          }
          w = Math.min(w, max);
          $dropdown.css({'width': w + 'px'});
          $dropdown.attr('data-width-set', window.innerWidth);
        }
      };

      /**
       * EVENTS
       */

      $toggleBtn.click(function(e) {
        // change the icon and text to reflect the state
        if ($globalHeader.hasClass('open')) {
          $globalHeader.removeClass('open');
          $globalHeader.find('.menu-toggle-label').text('Menu');
        }
        else {
          $globalHeader.addClass('open');
          $globalHeader.find('.menu-toggle-label').text('Close');
        }
      });

      // Closes menu if clicked outside
      jQuery(document).on('click', function(event) {
        var $trigger = jQuery('.dropdown-container');
        if ($trigger !== event.target && !$trigger.has(event.target).length) {
          jQuery('.dropdown-container').collapse('hide');
        }
      });

      // trap focus when mobile menu is opened
      jQuery('.header-collapse').on('show.bs.collapse', function(e) {
        if (focusTraps.header) {
          focusTraps.header.activate();
          jQuery('.global-header').addClass('header-open');
        }
      });

      // Release focus trap when mobile menu is closed
      jQuery('.header-collapse').on('hide.bs.collapse', function(e) {
        if (focusTraps.header) {
          focusTraps.header.deactivate();
          jQuery('.global-header').removeClass('header-open');
        }
      });

      // Align mega menus with the left edge of the screen
      jQuery('.nav-item--level-0 > .dropdown-style-mega-menu').on('show.bs.collapse', function(e) {
        const $dropdown = jQuery(this);
        alignMegaMenuLeft($dropdown);
      });

      // Deactivate focus trap and collapse all children
      $globalHeader.find('.dropdown-container').on('hide.bs.collapse', function(e) {
        const $dropdown = jQuery(e.target);
        const trapId = $dropdown.attr('id');
        // collapse any children
        $dropdown.find('.collapse').collapse('hide');
        // deactivate focus trap
        if (focusTraps[trapId]) {
          focusTraps[trapId].deactivate();
        }
      });

      // Scope focus trap to the current menu on mobile
      $globalHeader.find('.dropdown-container').on('show.bs.collapse', function(e) {
        //HERE
        const $dropdown = jQuery(e.target);
        setDropdownWidth($dropdown);
        const focuables = [$dropdown[0], $headerRegion[0], $toggleBtn[0]];
        // adjust timing according to CSS
        const duration = parseFloat($dropdown.css('transition-duration')) * 1000;
        const delay = parseFloat($dropdown.css('transition-delay')) * 1000;


        if (window.innerWidth < mobileMenuBreakpoint) {
          setTimeout(function() {
            const trapId = $dropdown.attr('id');
            const options = {...focusTrapsOptions}; // shallow copy of default
            // prevent scrolling to the element while it moves into view
            options.preventScroll = true;
            focusTraps[trapId] = focusTrap.createFocusTrap(focuables, options);
            focusTraps[trapId].activate();
          }, (duration + delay));
        }
      });

      // Functions to run after the user has finished resizing the window.
      jQuery(window).resize(function() {
        winResizeBounce = setTimeout(function() {
          clearTimeout(winResizeBounce);
          $globalHeader.find('collapse').collapse('hide');
          $globalHeader.find('dropdown-container').removeAttr('style');
          headerTabIndexFix();
          headerCollapsePinTop();
        }, 100);
      });

      // Document Ready.
      jQuery(document).ready(function() {
        headerTabIndexFix();
        headerCollapsePinTop();
      });
    }
  };
})(jQuery, Drupal, focusTrap);
